import { TestimonialInterface } from '../interfaces/testimonial.interface';

export const TESTIMONIALS: TestimonialInterface[] = [
  {
    content: "TESTIMONIALS.TESTIMONIALS.ECOMMERCE_MANAGER.CONTENT",
    company: "TESTIMONIALS.TESTIMONIALS.ECOMMERCE_MANAGER.COMPANY"
  },
  {
    content: "TESTIMONIALS.TESTIMONIALS.RETAIL_OWNER.CONTENT",
    company: "TESTIMONIALS.TESTIMONIALS.RETAIL_OWNER.COMPANY"
  }
  // Continue similar pattern for other testimonials
];